module.exports = __webpack_public_path__ + "static/media/H2_Large_Vote.6c9f2ed6.svg";